// 2DO: aria, wcag
define(['jquery'], function ($) {

  $.fn.pkoAccordion = function (_options) {

    var options = $.extend({}, $.fn.pkoAccordion.defaults, _options);

    function init(elem) {

      var $accordion = $(elem),
        $items,
        itemsLength;

      function setUp() {

        $accordion.data('unrolled', false);

        $items.on('click', '.' + options.itemHeaderClass, function () {
          var $this = $(this),
            parent = $this.parent(),
            parentShown = parent.is('.shown');
          parent[((parentShown) ? 'remove' : 'add') + 'Class'](options.shownClass);
          $this.next()['slide' + ((parentShown) ? 'Up' : 'Down')]();
        });

        $accordion.on('click', '.' + options.unrollClass, function (e) {
          var $this = $(this),
            unrolled = $accordion.data('unrolled');
          $accordion.find('.' + options.itemClass)[((unrolled) ? 'remove' : 'add') + 'Class'](options.shownClass);
          $accordion.find('.' + options.itemBodyClass)['slide' + ((unrolled) ? 'Up' : 'Down')]();
          $this[((unrolled) ? 'remove' : 'add') + 'Class'](options.shownClass);
          // $this.find( 'span' ).text( $this.data( ( unrolled ) ? 'unroll' : 'roll' ) );
          // $accordion.find( '.' + options.unrollClass + ' span' ).not( $this ).text( $this.data( ( unrolled ) ? 'unroll' : 'roll' ) );
          $accordion.find('.' + options.unrollClass + ' span').text((unrolled) ? options.unrollText : options.rolltext);
          unrolled = !unrolled;
          $accordion.data('unrolled', unrolled);
          e.preventDefault();
        });

      }

      $items = $accordion.find('li');
      itemsLength = $items.length;

      setUp();

    }

    return this.each(function () {
      init(this);
    });

  };

  $.fn.pkoAccordion.defaults = {
    itemClass: 'accordion__item',
    itemBodyClass: 'accordion__content',
    itemHeaderClass: 'accordion__heading',
    unrollClass: 'accordion__unroll',
    unrollText: 'Rozwiń',
    rolltext: 'Zwiń',
    shownClass: 'shown'
  };


});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/lib/jquery.pkoAccordion.js